module.exports = __webpack_public_path__ + "static/img/19.38b763d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/logos/19.png
// module id = DfVb
// module chunks = 10